import React, { useState } from 'react';
import { func, arrayOf, object, string, oneOfType, number, bool, shape } from 'prop-types';
import { Box } from '../../atoms';
import { RadioGroup } from '../../molecules';
import { Sidebar } from '../../organisms';
import FilterMenu from '../FilterMenu';
import { ListOptions, Text } from './toolbar.styles';
import ListDisplayType from '../../molecules/ListDisplayType';
export default function Toolbar({
  defaultDisplayMode,
  onChangeDisplayMode,
  onChangeSort,
  onFiltersClear,
  onFilterClick,
  onFilterItemClick,
  onFilterTypeClick,
  sortOptions,
  sortLabel,
  showSelectedOptionLabel,
  filters,
  showFilters,
  filtersCount,
  showDisplayType
}) {
  var _sortOptions$find;

  const [sortOpen, setSortOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);

  function handleSortChange(e, option) {
    onChangeSort(option);
    setSortOpen(false);
  }

  const handleFiltersClear = () => {
    setFilterOpen(!filterOpen);
    onFiltersClear();
  };

  const handleFilterClick = () => {
    onFilterClick(!filterOpen);
    setFilterOpen(!filterOpen);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ListOptions, {
    fontSize: 1
  }, showDisplayType && !!onChangeDisplayMode && /*#__PURE__*/React.createElement(ListDisplayType, {
    onChange: onChangeDisplayMode,
    defaultMode: defaultDisplayMode
  }), sortOptions != null && sortOptions.length ? /*#__PURE__*/React.createElement(Box, {
    p: 1,
    onClick: () => setSortOpen(!sortOpen),
    "data-testid": "orderby-btn"
  }, /*#__PURE__*/React.createElement(Text, {
    "data-testid": "sort-label"
  }, showSelectedOptionLabel ? ((_sortOptions$find = sortOptions.find(option => option.selected)) == null ? void 0 : _sortOptions$find.label) || sortLabel : sortLabel)) : /*#__PURE__*/React.createElement(React.Fragment, null), showFilters && /*#__PURE__*/React.createElement(FilterMenu, {
    visible: filterOpen,
    filters: filters,
    count: filtersCount,
    onItemClick: onFilterItemClick,
    onOpen: handleFilterClick,
    onClickOutside: handleFilterClick,
    onClose: handleFilterClick,
    onClear: handleFiltersClear,
    onShowDetail: onFilterTypeClick
  })), sortOptions != null && sortOptions.length ? /*#__PURE__*/React.createElement(Sidebar, {
    headerTitle: sortLabel,
    visible: sortOpen,
    direction: "right",
    onClickOutside: () => setSortOpen(false)
  }, /*#__PURE__*/React.createElement(RadioGroup, {
    options: sortOptions,
    onChange: handleSortChange,
    p: '12px 0 12px 20px'
  })) : /*#__PURE__*/React.createElement(React.Fragment, null));
}
Toolbar.defaultProps = {
  defaultDisplayMode: 'gallery',
  onChangeSort: () => {},
  onFiltersClear: () => ({}),
  onFilterClick: () => ({}),
  onFilterItemClick: {},
  sortLabel: 'Ordenar por',
  sortOptions: [],
  showSelectedOptionLabel: true,
  filters: {},
  filtersCount: 0,
  showFilters: false,
  showDisplayType: false
};
process.env.NODE_ENV !== "production" ? Toolbar.propTypes = {
  defaultDisplayMode: string,
  onChangeDisplayMode: func,
  onChangeSort: func,
  onFiltersClear: func,
  onFilterClick: func,
  onFilterTypeClick: func,
  onFilterItemClick: shape({
    attributeFilter: func,
    reviewFilter: func,
    categoryFilter: func,
    priceFilter: func
  }),
  showSelectedOptionLabel: bool,
  sortOptions: arrayOf(object),
  sortLabel: string,
  filters: oneOfType([arrayOf(object), object]),
  filtersCount: number,
  showFilters: bool,
  showDisplayType: bool
} : void 0;